import React, { useState, useEffect } from 'react';
import Typewriter from 'typewriter-effect';
import Fade from 'react-reveal';
import endpoints from '../constants/endpoints';
import Social from './Social';
import FallbackSpinner from './FallbackSpinner';

const sharedGradient = {
  background: 'linear-gradient(135deg, #ff9a9e, #a18cd1)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
};

const styles = {
  nameStyle: {
    fontSize: '5em',
    fontWeight: 'bold',
    ...sharedGradient,
  },
  inlineChild: {
    display: 'inline',
    fontSize: '2em',
    fontWeight: 'bold',
    margin: 0,
    padding: 0,
    verticalAlign: 'baseline',
    ...sharedGradient,
  },
  typewriterContainer: {
    display: 'inline',
    fontSize: '2em',
    fontWeight: 'bold',
    verticalAlign: 'baseline',
    ...sharedGradient,
  },
  mainContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

function Home() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(endpoints.home, {
      method: 'GET',
    })
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((err) => err);
  }, []);

  return data ? (
      <>
          <Fade>
              <div style={styles.mainContainer}>
                  <h1 style={styles.nameStyle}>{data?.name}</h1>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                      <span style={styles.inlineChild}>I&apos;m&nbsp;</span>
                      <span style={styles.typewriterContainer}>
                          <Typewriter
                              options={{
                                  loop: true,
                                  autoStart: true,
                                  strings: data?.roles,
                              }}
                          />
                      </span>
                  </div>
                  <Social />
              </div>
          </Fade>
      </>
  ) : <FallbackSpinner />;
}

export default Home;
